export function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

type ChartLike = {
  labels?: string[];
  datasets?: Array<{ data?: number[] }>;
};

/** Gráfico com ao menos um dataset e labels válidos. */
export function hasChartData(chart?: ChartLike | null): boolean {
  if (!chart?.datasets?.length || !chart.labels?.length) return false;
  return chart.datasets.every(
    (ds) => Array.isArray(ds.data) && ds.data.length === chart.labels!.length
  );
}

/** Gráfico com algum valor numérico diferente de zero. */
export function hasChartValues(chart?: ChartLike | null): boolean {
  if (!hasChartData(chart)) return false;
  return chart!.datasets!.some((ds) =>
    ds.data!.some((n) => isFiniteNumber(n) && n !== 0)
  );
}
